import { Typography as DSTypography } from '@ghq-abi/design-system-v2';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Typography = (props: any) => {
  return <DSTypography {...props} />;
};
